var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { useWithSound } from '../../audio-engine/hooks/use-sound';
var useStyles = makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        numeric: {
            fontFamily: typography.fontFamilies.numeric,
            fontWeight: 700
        }
    });
});
export var UIText = React.forwardRef(function (_a, ref) {
    var variant = _a.variant, onClick = _a.onClick, propsRest = __rest(_a, ["variant", "onClick"]);
    var classes = useStyles();
    var withSound = useWithSound('buttonClick');
    var rest = __assign(__assign({}, propsRest), { onClick: withSound(onClick), ref: ref });
    if (variant === 'numeric') {
        return React.createElement(Typography, __assign({}, rest, { className: clsx(classes.numeric, rest.className), variant: 'body2' }));
    }
    return React.createElement(Typography, __assign({ variant: variant }, rest));
});
